import "animate.css";
import it from 'date-fns/locale/it';
import moment from 'moment';
import 'moment/locale/it';
import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt, FaChevronCircleLeft } from 'react-icons/fa';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import utils from '../../modules/utils';
import "./Agenda.scss";
registerLocale('it', it);

const Agenda = ({apiClient, btnLabel, bgColor, selectOrario, agenda}) => {      
  const [loaded, setLoaded] = useState(false)
  const [showAgenda, showHideAgenda] = useState(false)
  const [dati, setDati] = useState()
  const [disponibilita, setDisponibilita] = useState({})
  const [anni, setAnni] = useState({})
  const [daySel, setDaySel] = useState(null)      
  
  const checkDisponibilita = () => {            
    apiClient.fnGetDisponibilita((res)=>{      
      setLoaded(true)             
      setDati(res.disponibilita)
      showHideAgenda(true)        
    });    
  }

  const selezionaOrario = (giorno, orario) => {
    setDaySel(null)
    selectOrario(giorno, orario)
    showHideAgenda(false)
  }

  const annulla = () => {    
    setDaySel(null)
    showHideAgenda(false)
  }

  useEffect(()=>{    
    if(dati && dati.length>0){      
      let _disponibilita = {}
      dati.forEach(item=>{
        const data = moment(item.DATA_APPUNTAMENTO, 'YYYYMMDD').format("DD/MM/YYYY")
        const orario = moment(item.ORARIO, 'HHmm').format('HH:mm')
        if(_disponibilita[data]===undefined){
          _disponibilita[data] = [];
        }
        _disponibilita[data].push({
          ID_DISPONIBILITA: item.KID, 
          orario: orario
        });
      });      
      setDisponibilita(_disponibilita)
    }
    
  }, [dati])

  useEffect(()=>{    
    if(Object.keys(disponibilita).length>0){
      let _anni = {}
      Object.keys(disponibilita).forEach(data=>{        
        const dataEl = data.split("/");
        if( typeof _anni[dataEl[2]] === "undefined" ){      
          _anni[dataEl[2]] = [];                           
        }    
        if( _anni[dataEl[2]].indexOf(dataEl[1]) < 0 ){
          _anni[dataEl[2]].push(dataEl[1]);
        }            
      })                
      setAnni(_anni)
    }
  }, [disponibilita])
 
  return (
    <div style={{paddingTop: '10px', paddingBottom: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>      

      { !showAgenda && (
        <Button className="text-light agenda-button" style={{backgroundColor: bgColor}} onClick={checkDisponibilita}>
          <FaCalendarAlt /> { `${agenda.giorno === "" ? 'Seleziona un giorno / orario' : 'Modifica giorno / orario'} ${btnLabel}`}
        </Button>
      )}
      {Object.keys(disponibilita).length > 0 && (
      <div className={`${showAgenda ? 'd-block' : 'd-none'}`}>
        <div style={{width: '100%', padding: 10, borderRadius: 20, overflow: 'hidden'}} className="agenda-mobile">                  
          <Form.Group>
            <label style={{fontSize: '1.5em'}}>Giorno</label>          
            <DatePicker minDate={daySel} 
                        placeholderText="Seleziona un giorno..."
                        includeDates={Object.keys(disponibilita).map( data => moment(data, "DD/MM/YYYY") ).map( data => data.toDate() )}
                        className="form-control"                      
                        onChangeRaw={(e)=>e.preventDefault()}                      
                        onChange={(val) => {                           
                          setDaySel(moment(val).format("DD/MM/YYYY")); 
                        }}  
                        selected={daySel ? moment(daySel, "DD/MM/YYYY").utc().toDate() : null}                        
                        dateFormat="dd/MM/yyyy"
                        locale="it" />
            
            { daySel && (
              <>
                <label style={{fontSize: '1.5em'}}>Orario</label>
                <Form.Select size="sm" aria-label="Orario" onChange={(e) => selezionaOrario(daySel, e.target.value)}>
                  <option >Seleziona...</option>
                  { disponibilita[daySel].map( (orario, idx_orario)  => 
                  <option key={idx_orario} value={orario.orario}>{orario.orario}</option>
                  )}          
                </Form.Select>
              </>
            )}
          </Form.Group>
        </div>
        
        <div style={{maxWidth: '530px', borderRadius: 20, overflow: 'hidden'}} className="agenda">           
          <Carousel showIndicators={false} 
                    showStatus={false} 
                    showArrows={!daySel} 
                    autoPlay={false} 
                    interval={100000}
                    showThumbs={false}
                    >
            { Object.keys(anni).sort().map( anno => 
              anni[anno].sort().map( mese =>        
                <div key={`${anno}${mese}`} className={!daySel ? "agenda-container" : "agenda-container-alt"}>                     
                  <span className="agenda-anno"><strong>{anno}</strong></span>
                  <h1 className="agenda-mese">{utils.getDescMese(mese)}</h1>             
                  <div className={`agenda-days-container ${daySel ? 'flex-1 d-flex flex-row align-items-flex-start justify-content-center' : ''}`}>                 
                    { Object.keys(disponibilita).sort().map( (data, index) => {                                                              
                      if( (!daySel || daySel === data) && data.split("/")[2] === anno && data.split("/")[1] === mese){
                        return (
                        <div key={index} className={`agenda-day ${moment(data, 'DD/MM/YYYY').format('ddd') === 'sab' || moment(data, 'DD/MM/YYYY').format('ddd') === 'dom' ? 'festivo' : ''} ${daySel === data ? 'animate__animated animate__bounceIn selected' : ""}`} title="Seleziona questo giorno" onClick={()=>{
                          if( !daySel ) {
                            setDaySel(data)
                          }else{
                            setDaySel(null)
                          }
                          }}>
                          <span>{moment(data, 'DD/MM/YYYY').format('ddd')}</span>
                          <h1>{data.split("/")[0]}</h1>
                        </div>
                        )
                      }
                      return null;
                    })}
                    { daySel && daySel.split("/")[1] === mese && (
                      <>
                        <div className="orari p-4 animate__animated animate__backInRight">                                      
                          <h3 className="title-fascia-oraria">Orario</h3>
                          <div className="orari-container">
                          { disponibilita[daySel].map( (orario, idx_orario)  => 
                            <div key={idx_orario} className="d-grid gap-2">
                              <Button variant="outline-primary" className="m-1 orario" onClick={()=>selezionaOrario(daySel, orario)}>
                                {orario.orario}
                              </Button>
                            </div>
                          )}  
                          </div>
                          <div className="arrow arrow-left" />                
                        </div>                                    
                      </>
                    )}              
                  </div>
                  { daySel && (
                    <div className="orari-close" onClick={()=>setDaySel(null)}>
                      <FaChevronCircleLeft /> <span>Indietro</span>
                    </div>
                  )}
                </div>
            ))}                       
          </Carousel>                 
          <div className={`d-block p-2 text-center ${!daySel ? 'bg-secondary' : 'bg-secondary'}`}>
            { showAgenda && (
              <Button variant="light" onClick={annulla}>Annulla</Button>
            )}
          </div>
        </div>          
      </div>  
      )}  
      { loaded && dati.length===0 && (
        <h3>Al momento non è possibile prendere un appuntamento: nessuna data disponibile.</h3>
      )}
    
  </div>
  )
}

export default Agenda;